module.exports = __webpack_public_path__ + "img/tips.c63b1784.png";